export default __webpack_public_path__ + "static/media/result-active.0abed8c6.svg";